package utils

import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.Dispatchers

actual val Dispatchers.IO_MULTI: CoroutineDispatcher get() = Dispatchers.Default